import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHD = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_OBRAS_AHD", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHD;
